<template>
    <div class="col-12 item-container pointer box-shadow" v-on:click="selected">
        <div class="item-pic">
            <fair-image
                        :image-id="member.photo ? member.photo.id : null"
                        rounded = "circle"
                        class="item-pic-circle"
            />
        </div>
        <div class="item-content">
            <div class="col-12">
                <h4>{{ member.last_name }}, {{member.first_name}}</h4>
            </div>
        </div>
        <div v-if="canDelete"
             class="round-btn bottom-right"
             @click.stop="$emit('remove', member)">
            <font-awesome-icon icon="trash"/></div>
    </div>
</template>

<script>

    import FairImage from "../FairImage";

    export default {
        name: "member-item",
        components: {FairImage},
        props: {
            member: {
                type: Object,
                default: null
            },
            canDelete: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
            }
        },
        methods: {
            selected: function () {
                if (!this.canDelete) {
                    this.$router.push({name: 'user-campaign-view', params: {id: this.member.id, userInfo: this.member}})
                }
            }
        }
    }
</script>

<style scoped>
</style>
